// App.jsx (oder .tsx, wenn du TS weiterbenutzt)
import { useEffect, useState } from "react";
import { CarTile } from "./components/CarTile";
import "./App.css";

export default function App() {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function load() {
      try {
        const res = await fetch("https://backend.demo.verse.koeln/api/cars");
        if (!res.ok) throw new Error("Request failed " + res.status);
        const data = await res.json();
        setCars(data); // ← hier kommt dein Array an
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  if (loading) return <p>Lade …</p>;
  if (error) return <p>Fehler: {error.message}</p>;

  return (
    <main className="car-grid">
      {cars.map((car) => (
        <CarTile key={car.id} car={car} />
      ))}
    </main>
  );
}
